import React, { useState } from "react";
import "./DonwloadIcon.css";
import { MdOutlineCloudDownload } from "react-icons/md";
import { IconContext } from "react-icons";
import BackupService from "../../services/BackupService";
import { useUserStore } from "../../contexts/userStore";
import Loader from "../Loader/Loader";
import { isValidUrl } from "../../utils/url";

const DownloadIcon = (props) => {
	const { selectedLicenceId } = useUserStore();
	const [showLoader, setShowLoader] = useState(false);

	function download(data) {
		const downloadUrl = window.URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
		const link = document.createElement("a");
		link.href = downloadUrl;
		const objectKeyParts = props.data?.bucketKey.split('/');
		link.setAttribute("download", `${objectKeyParts[objectKeyParts.length - 1]}`);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}

	const handleIconClick = async (e) => {
		e.stopPropagation();
		setShowLoader(true);
		if (props.listEntityName === "backups") {
			const response = await BackupService.downloadBackupById(props.data?.id);
			setShowLoader(false);
			if (response.status !== 200) {
				return;
			}

			if (response.headers['content-type'].indexOf('text/plain') !== -1) {
				if (isValidUrl(response.data)) {
					const responseUrl = await fetch(response.data);
					if (responseUrl.ok) {
						download(await responseUrl.blob());
					}
				}
			} else {
				download(response.data);
			}
		}

	};

	if ([5].includes(props.data.status)) {
		return <span className="download-icon-disabled">---</span>;
	}

	if (!props.data.uploadedAt) {
		return (
			<Loader width={20} height={20} style={{ marginTop: '0px' }} />
		);
	}

	return (
		<IconContext.Provider value={{ className: "download-icon" }}>
			{showLoader ? (
				<Loader width={20} height={20} style={{ marginTop: '0px' }} />
			) : (
				<MdOutlineCloudDownload size={25} onClick={handleIconClick} />
			)}
		</IconContext.Provider>
	);
};

export default DownloadIcon;
